import React, { useRef, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Swiper, SwiperSlide } from "swiper/react";
import axios from "axios";
import toast from "react-hot-toast";
import { Helmet } from "react-helmet";

import axiosInstance from "../../axiosInstance";
 
const CategoryTest = () => {
 
  return (
    <>
      <Header />
 
      <div className="breadcrumb-bar text-center">
  <div className="container">
    <div className="row">
      <div className="col-md-12 col-12">
        <h2 className="breadcrumb-title mb-2">Services</h2>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb justify-content-center mb-0">
            <li className="breadcrumb-item">
              <a href="/">
                <i className="ti ti-home-2" />
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Services
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <div className="breadcrumb-bg">
      <img
        src="/front/img/bg/breadcrumb-bg-01.png"
        className="breadcrumb-bg-1"
        alt="Img"
      />
      <img
        src="/front/img/bg/breadcrumb-bg-02.png"
        className="breadcrumb-bg-2"
        alt="Img"
      />
    </div>
  </div>
</div>


<div className="page-wrapper">
  <div className="content">
    <div className="container">
      <div className="row">
        <div className="col-xl-3 col-lg-4 theiaStickySidebar">
          <div className="card mb-4 mb-lg-0">
            <div className="card-body">
              <form
                action="/services"
                method="GET"
                id="filterForm"
              >
                <div className="d-flex align-items-center justify-content-between mb-3 pb-3 border-bottom">
                  <h5>
                    <i className="ti ti-filter-check me-2" />
                    Filters
                  </h5>
                  <a href="/services">
                    Reset Filter
                  </a>
                </div>
                <div className="mb-3 pb-3 border-bottom">
                  <label className="form-label">Search By Keyword</label>
                  <input
                    type="text"
                    name="keywords"
                    id="keywords"
                    className="form-control"
                    maxLength={50}
                    placeholder="what are you looking for"
                  />
                </div>
                <div className="accordion border-bottom mb-3">
                  <div className="accordion-item mb-3">
                    <div
                      className="accordion-header"
                      id="accordion-headingThree"
                    >
                      <div
                        className="accordion-button p-0 mb-3"
                        data-bs-toggle="collapse"
                        data-bs-target="#accordion-collapseThree"
                        aria-expanded="true"
                        aria-controls="accordion-collapseThree"
                        role="button"
                      >
                        Categories
                      </div>
                    </div>
                    <div
                      id="accordion-collapseThree"
                      className="accordion-collapse collapse show"
                      aria-labelledby="accordion-headingThree"
                    >
                      <div className="content-list mb-3" id="fill-more">
                        <div className="form-check mb-2">
                          <label className="form-check-label">
                            <input
                              className="form-check-input"
                              id="all_categories"
                              type="checkbox"
                            />
                            All Category
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="accordion border-bottom mb-3">
                  <div className="accordion-header" id="accordion-headingFour">
                    <div
                      className="accordion-button p-0 mb-3"
                      data-bs-toggle="collapse"
                      data-bs-target="#accordion-collapseFour"
                      aria-expanded="true"
                      aria-controls="accordion-collapseFour"
                      role="button"
                    >
                      Sub Category
                    </div>
                  </div>
                  <div
                    id="accordion-collapseFour"
                    className="accordion-collapse collapse show"
                    aria-labelledby="accordion-headingFour"
                  >
                    <div className="mb-3">
                      <select
                        className="form-select"
                        name="subcategory"
                        id="subcategory"
                      >
                        <option selected="" disabled="">
                          {" "}
                          Select subCategory
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="accordion border-bottom mb-3">
                  <div className="accordion-header" id="accordion-headingFive">
                    <div
                      className="accordion-button p-0 mb-3"
                      data-bs-toggle="collapse"
                      data-bs-target="#accordion-collapseFive"
                      aria-expanded="true"
                      aria-controls="accordion-collapseFive"
                      role="button"
                    >
                      Location
                    </div>
                  </div>
                  <div
                    id="accordion-collapseFive"
                    className="accordion-collapse collapse show"
                    aria-labelledby="accordion-headingFive"
                  >
                    <div className="mb-3">
                      <div className="position-relative">
                        <select
                          className="form-select"
                          name="location"
                          id="location"
                        >
                          <option value="" selected="">
                            Select Location
                          </option>
                          <option value={37541}>Banska Bystrica</option>
                          <option value={5909}>Eshkashem</option>
                          <option value={9783}>Sevlievo</option>
                          <option value="" />
                          <option value={3683}>Coimbatore</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="accordion border-bottom mb-3">
                  <div className="accordion-header" id="accordion-headingSix">
                    <div
                      className="accordion-button p-0 mb-3"
                      data-bs-toggle="collapse"
                      data-bs-target="#accordion-collapseSix"
                      aria-expanded="true"
                      aria-controls="accordion-collapseSix"
                      role="button"
                    >
                      Price range
                    </div>
                  </div>
                  <div
                    id="accordion-collapseSix"
                    className="accordion-collapse collapse show"
                    aria-labelledby="accordion-headingSix"
                  >
                    <div className="filter-range">
                      <input
                        type="text"
                        id="range"
                        className="range"
                        name="range_price"
                      />
                    </div>
                    <div className="filter-range-amount mb-3">
                      <p className="fs-14" id="price_display">
                        Price <span />
                      </p>
                    </div>
                  </div>
                </div>
                <div className="accordion">
                  <div className="accordion-item mb-3">
                    <div className="accordion-header" id="accordion-headingTwo">
                      <div
                        className="accordion-button fs-18 p-0 mb-3"
                        data-bs-toggle="collapse"
                        data-bs-target="#accordion-collapseTwo"
                        aria-expanded="true"
                        aria-controls="accordion-collapseTwo"
                        role="button"
                      >
                        Ratings
                      </div>
                    </div>
                    <div
                      id="accordion-collapseTwo"
                      className="accordion-collapse collapse show"
                      aria-labelledby="accordion-headingTwo"
                    >
                      <div className="mb-3">
                        <div className="form-check mb-2">
                          <label className="form-check-label d-block">
                            <input
                              className="form-check-input rating_filter"
                              name="rating[]"
                              defaultValue={5}
                              type="checkbox"
                            />
                            <span className="rating">
                              <i className="fas fa-star filled" />
                              <i className="fas fa-star filled" />
                              <i className="fas fa-star filled" />
                              <i className="fas fa-star filled" />
                              <i className="fas fa-star filled" />
                              <span className="float-end" />
                            </span>
                          </label>
                        </div>
                        <div className="form-check mb-2">
                          <label className="form-check-label d-block">
                            <input
                              className="form-check-input rating_filter"
                              name="rating[]"
                              defaultValue={4}
                              type="checkbox"
                            />
                            <span className="rating">
                              <i className="fas fa-star filled" />
                              <i className="fas fa-star filled" />
                              <i className="fas fa-star filled" />
                              <i className="fas fa-star filled" />
                              <i className="fa-regular fa-star filled" />
                              <span className="float-end" />
                            </span>
                          </label>
                        </div>
                        <div className="form-check mb-2">
                          <label className="form-check-label d-block">
                            <input
                              className="form-check-input rating_filter"
                              name="rating[]"
                              defaultValue={3}
                              type="checkbox"
                            />
                            <span className="rating">
                              <i className="fas fa-star filled" />
                              <i className="fas fa-star filled" />
                              <i className="fas fa-star filled" />
                              <i className="fa-regular fa-star filled" />
                              <i className="fa-regular fa-star filled" />
                              <span className="float-end" />
                            </span>
                          </label>
                        </div>
                        <div className="form-check mb-2">
                          <label className="form-check-label d-block">
                            <input
                              className="form-check-input rating_filter"
                              name="rating[]"
                              defaultValue={2}
                              type="checkbox"
                            />
                            <span className="rating">
                              <i className="fas fa-star filled" />
                              <i className="fas fa-star filled" />
                              <i className="fa-regular fa-star filled" />
                              <i className="fa-regular fa-star filled" />
                              <i className="fa-regular fa-star filled" />
                              <span className="float-end" />
                            </span>
                          </label>
                        </div>
                        <div className="form-check mb-2">
                          <label className="form-check-label d-block">
                            <input
                              className="form-check-input rating_filter"
                              name="rating[]"
                              defaultValue={1}
                              type="checkbox"
                            />
                            <span className="rating">
                              <i className="fas fa-star filled" />
                              <i className="fa-regular fa-star filled" />
                              <i className="fa-regular fa-star filled" />
                              <i className="fa-regular fa-star filled" />
                              <i className="fa-regular fa-star filled" />
                              <span className="float-end" />
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  className="btn btn-dark w-100"
                  id="searchServiceBtn"
                >
                  Search
                </button>
              </form>
            </div>
          </div>
        </div>
        <div className="col-xl-9 col-lg-8">
          <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">
            <h4>
              Found <span className="text-primary">16 Services</span>
            </h4>
            <form
              action="/services"
              method="GET"
              id="sortform"
            >
              <div className="d-flex align-items-center">
                <span className="text-dark me-2">Sort</span>
                <select
                  className="form-select"
                  name="sortprice"
                  id="sortprice"
                  onchange="if (!window.__cfRLUnblockHandlers) return false; this.form.submit()"
                  data-cf-modified-1244ef23e0f85180b8822953-=""
                >
                  <option value="">Price Low to High</option>
                  <option value="highl">Price High to Low</option>
                </select>
                <input type="hidden" name="category" defaultValue="carwash" />
              </div>
            </form>
          </div>
          <div className="row align-items-center">
            <div className="col-xl-4 col-md-6">
              <div className="card p-0">
                <div className="card-body p-0">
                  <div className="img-sec w-100">
                    <Link
                      to="/product"
                      className="serv_img"
                    >
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Placeholder_view_vector.svg/800px-Placeholder_view_vector.svg.png#toVMzhD7PYdjWM7P1AJ0pl9SDap2kY0UAqTixKCQ.jpg"
                        className="img-fluid rounded-top w-100"
                        alt="img"
                      />
                    </Link>
                    <div className="image-tag d-flex justify-content-end align-items-center">
                      <span className="trend-tag">Car Wash</span>
                      <a
                        href="javascript:void(0);"
                        onclick="if (!window.__cfRLUnblockHandlers) return false; addfavour(15)"
                        className="fav-icon like-icon"
                        data-cf-modified-1244ef23e0f85180b8822953-=""
                      >
                        <i className="ti ti-heart" />
                      </a>
                    </div>
                  </div>
                  <div className="p-3">
                    <h5 className="mb-2">
                      <Link
                                            to="/product"

                      >
                        10K Car Washing555
                      </Link>
                    </h5>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <p className="fs-14 mb-0">
                        <i className="ti ti-map-pin me-2" />
                        Sevlievo, Lovech
                      </p>
                      <span className="rating text-gray fs-14">
                        <i className="fa fa-star filled me-1" />
                        3.0
                      </span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <h5>Mad200/Min </h5>
                      <a
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#login-modal"
                        className="btn bg-primary-transparent"
                      >
                        Book Now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="card p-0">
                <div className="card-body p-0">
                  <div className="img-sec w-100">
                    <Link
                                           to="/product"

                      className="serv_img"
                    >
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Placeholder_view_vector.svg/800px-Placeholder_view_vector.svg.png#kyYjrRpZbV6VONgPTr1G50tCbQzvZoUXmOVIgyhc.jpg"
                        className="img-fluid rounded-top w-100"
                        alt="img"
                      />
                    </Link>
                    <div className="image-tag d-flex justify-content-end align-items-center">
                      <span className="trend-tag">Car Wash</span>
                      <a
                        href="javascript:void(0);"
                        onclick="if (!window.__cfRLUnblockHandlers) return false; addfavour(17)"
                        className="fav-icon like-icon"
                        data-cf-modified-1244ef23e0f85180b8822953-=""
                      >
                        <i className="ti ti-heart" />
                      </a>
                    </div>
                  </div>
                  <div className="p-3">
                    <h5 className="mb-2">
                      <Link to="/product"
                       >
                        20K Car Washing
                      </Link>
                    </h5>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <p className="fs-14 mb-0">
                        <i className="ti ti-map-pin me-2" />
                        Banska Bystrica, Presovsky
                      </p>
                      <span className="rating text-gray fs-14">
                        <i className="fa fa-star filled me-1" />
                        5.0
                      </span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <h5>Mad300/Hr </h5>
                      <a
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#login-modal"
                        className="btn bg-primary-transparent"
                      >
                        Book Now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="card p-0">
                <div className="card-body p-0">
                  <div className="img-sec w-100">
                    <Link
                     to="/product"
                      className="serv_img"
                    >
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Placeholder_view_vector.svg/800px-Placeholder_view_vector.svg.png#NF9sPx0kld50QopJlHBbfh2KRInIMiaRr6SNN2bW.jpg"
                        className="img-fluid rounded-top w-100"
                        alt="img"
                      />
                    </Link>
                    <div className="image-tag d-flex justify-content-end align-items-center">
                      <span className="trend-tag">Car Wash</span>
                      <a
                        href="javascript:void(0);"
                        onclick="if (!window.__cfRLUnblockHandlers) return false; addfavour(18)"
                        className="fav-icon like-icon"
                        data-cf-modified-1244ef23e0f85180b8822953-=""
                      >
                        <i className="ti ti-heart" />
                      </a>
                    </div>
                  </div>
                  <div className="p-3">
                    <h5 className="mb-2">
                      <Link to="/product" >
                        Car Wash
                      </Link>
                    </h5>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <p className="fs-14 mb-0">
                        <i className="ti ti-map-pin me-2" />
                        Sevlievo, Lovech
                      </p>
                      <span className="rating text-gray fs-14">
                        <i className="fa fa-star filled me-1" />
                        0.0
                      </span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <h5>Mad200 </h5>
                      <a
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#login-modal"
                        className="btn bg-primary-transparent"
                      >
                        Book Now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="card p-0">
                <div className="card-body p-0">
                  <div className="img-sec w-100">
                    <Link
                      to="/product"
                      className="serv_img"
                    >
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Placeholder_view_vector.svg/800px-Placeholder_view_vector.svg.png#qHzMFVWfKRC7Qyb0yaetmkBfjVz0WEGnRVIwSDNo.jpg"
                        className="img-fluid rounded-top w-100"
                        alt="img"
                      />
                    </Link>
                    <div className="image-tag d-flex justify-content-end align-items-center">
                      <span className="trend-tag">Car Wash</span>
                      <a
                        href="javascript:void(0);"
                        onclick="if (!window.__cfRLUnblockHandlers) return false; addfavour(19)"
                        className="fav-icon like-icon"
                        data-cf-modified-1244ef23e0f85180b8822953-=""
                      >
                        <i className="ti ti-heart" />
                      </a>
                    </div>
                  </div>
                  <div className="p-3">
                    <h5 className="mb-2">
                      <Link to="/product" >
                        MOUAJHID
                      </Link>
                    </h5>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <p className="fs-14 mb-0"></p>
                      <span className="rating text-gray fs-14">
                        <i className="fa fa-star filled me-1" />
                        0.0
                      </span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <h5>Mad200/Hr </h5>
                      <a
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#login-modal"
                        className="btn bg-primary-transparent"
                      >
                        Book Now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="card p-0">
                <div className="card-body p-0">
                  <div className="img-sec w-100">
                    <Link
                      to="/product"
                      className="serv_img"
                    >
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Placeholder_view_vector.svg/800px-Placeholder_view_vector.svg.png#Ec1I4yJuYMR7xbO2SdcQXXXwFqXj7veRgJkt5CwZ.jpg"
                        className="img-fluid rounded-top w-100"
                        alt="img"
                      />
                    </Link>
                    <div className="image-tag d-flex justify-content-end align-items-center">
                      <span className="trend-tag">Car Wash</span>
                      <a
                        href="javascript:void(0);"
                        onclick="if (!window.__cfRLUnblockHandlers) return false; addfavour(20)"
                        className="fav-icon like-icon"
                        data-cf-modified-1244ef23e0f85180b8822953-=""
                      >
                        <i className="ti ti-heart" />
                      </a>
                    </div>
                  </div>
                  <div className="p-3">
                    <h5 className="mb-2">
                      <Link to="/product">
                        10K Car Washing
                      </Link>
                    </h5>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <p className="fs-14 mb-0">
                        <i className="ti ti-map-pin me-2" />
                        Sevlievo, Lovech
                      </p>
                      <span className="rating text-gray fs-14">
                        <i className="fa fa-star filled me-1" />
                        0.0
                      </span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <h5>Mad200/Hr </h5>
                      <a
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#login-modal"
                        className="btn bg-primary-transparent"
                      >
                        Book Now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="card p-0">
                <div className="card-body p-0">
                  <div className="img-sec w-100">
                    <Link
                     to="/product"
                      className="serv_img"
                    >
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Placeholder_view_vector.svg/800px-Placeholder_view_vector.svg.png#2Yz4lfDziAqhhaKoPdhNoswKZIP3k0CZhuTAT2LO.jpg"
                        className="img-fluid rounded-top w-100"
                        alt="img"
                      />
                    </Link>
                    <div className="image-tag d-flex justify-content-end align-items-center">
                      <span className="trend-tag">Car Wash</span>
                      <a
                        href="javascript:void(0);"
                        onclick="if (!window.__cfRLUnblockHandlers) return false; addfavour(29)"
                        className="fav-icon like-icon"
                        data-cf-modified-1244ef23e0f85180b8822953-=""
                      >
                        <i className="ti ti-heart" />
                      </a>
                    </div>
                  </div>
                  <div className="p-3">
                    <h5 className="mb-2">
                      <Link to="/product">
                        10K Car Washing
                      </Link>
                    </h5>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <p className="fs-14 mb-0">
                        <i className="ti ti-map-pin me-2" />
                        Sevlievo, Lovech
                      </p>
                      <span className="rating text-gray fs-14">
                        <i className="fa fa-star filled me-1" />
                        0.0
                      </span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <h5>Mad200/Hr </h5>
                      <a
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#login-modal"
                        className="btn bg-primary-transparent"
                      >
                        Book Now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="card p-0">
                <div className="card-body p-0">
                  <div className="img-sec w-100">
                    <Link
                      to="/product"
                      className="serv_img"
                    >
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Placeholder_view_vector.svg/800px-Placeholder_view_vector.svg.png#EEuHPVIJ4Z1rGxlrT1pyln54Ws95TPMfppiZAi54.png"
                        className="img-fluid rounded-top w-100"
                        alt="img"
                      />
                    </Link>
                    <div className="image-tag d-flex justify-content-end align-items-center">
                      <span className="trend-tag">Car Wash</span>
                      <a
                        href="javascript:void(0);"
                        onclick="if (!window.__cfRLUnblockHandlers) return false; addfavour(88)"
                        className="fav-icon like-icon"
                        data-cf-modified-1244ef23e0f85180b8822953-=""
                      >
                        <i className="ti ti-heart" />
                      </a>
                    </div>
                  </div>
                  <div className="p-3">
                    <h5 className="mb-2">
                      <a href="/servicedetail/service-new">
                        Service New
                      </a>
                    </h5>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <p className="fs-14 mb-0"></p>
                      <span className="rating text-gray fs-14">
                        <i className="fa fa-star filled me-1" />
                        0.0
                      </span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <h5>Mad200 </h5>
                      <a
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#login-modal"
                        className="btn bg-primary-transparent"
                      >
                        Book Now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="card p-0">
                <div className="card-body p-0">
                  <div className="img-sec w-100">
                    <a
                      href="/servicedetail/kitchen-cleaning"
                      className="serv_img"
                    >
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Placeholder_view_vector.svg/800px-Placeholder_view_vector.svg.png#743izrjLmAVxt9KXRmvieGvCraKqJYHY0rFcNunE.jpg"
                        className="img-fluid rounded-top w-100"
                        alt="img"
                      />
                    </a>
                    <div className="image-tag d-flex justify-content-end align-items-center">
                      <span className="trend-tag">Car Wash</span>
                      <a
                        href="javascript:void(0);"
                        onclick="if (!window.__cfRLUnblockHandlers) return false; addfavour(89)"
                        className="fav-icon like-icon"
                        data-cf-modified-1244ef23e0f85180b8822953-=""
                      >
                        <i className="ti ti-heart" />
                      </a>
                    </div>
                  </div>
                  <div className="p-3">
                    <h5 className="mb-2">
                      <a href="/servicedetail/kitchen-cleaning">
                        Kitchen Cleaning
                      </a>
                    </h5>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <p className="fs-14 mb-0"></p>
                      <span className="rating text-gray fs-14">
                        <i className="fa fa-star filled me-1" />
                        0.0
                      </span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <h5>Mad200 </h5>
                      <a
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#login-modal"
                        className="btn bg-primary-transparent"
                      >
                        Book Now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="card p-0">
                <div className="card-body p-0">
                  <div className="img-sec w-100">
                    <Link
                      href="/servicedetail/wood-service"
                      className="serv_img"
                    >
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Placeholder_view_vector.svg/800px-Placeholder_view_vector.svg.png#"
                        className="img-fluid rounded-top w-100"
                        alt="img"
                      />
                    </Link>
                    <div className="image-tag d-flex justify-content-end align-items-center">
                      <span className="trend-tag">Car Wash</span>
                      <a
                        href="javascript:void(0);"
                        onclick="if (!window.__cfRLUnblockHandlers) return false; addfavour(96)"
                        className="fav-icon like-icon"
                        data-cf-modified-1244ef23e0f85180b8822953-=""
                      >
                        <i className="ti ti-heart" />
                      </a>
                    </div>
                  </div>
                  <div className="p-3">
                    <h5 className="mb-2">
                      <a href="/servicedetail/wood-service">
                        Wood service
                      </a>
                    </h5>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <p className="fs-14 mb-0"></p>
                      <span className="rating text-gray fs-14">
                        <i className="fa fa-star filled me-1" />
                        0.0
                      </span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <h5>Mad100 </h5>
                      <a
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#login-modal"
                        className="btn bg-primary-transparent"
                      >
                        Book Now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <nav aria-label="Page navigation">
            <ul className="paginations d-flex justify-content-center align-items-center">
              <li className="page-item me-2 disabled">
                <span className="d-flex justify-content-center align-items-center">
                  <i className="ti ti-arrow-left me-2" />
                  previous
                </span>
              </li>
              <li className="page-item me-2">
                <a
                  className="page-link-1 d-flex justify-content-center align-items-center active"
                  href="/services/carwash?page=1"
                >
                  1
                </a>
              </li>
              <li className="page-item me-2">
                <a
                  className="page-link-1 d-flex justify-content-center align-items-center "
                  href="/services/carwash?page=2"
                >
                  2
                </a>
              </li>
              <li className="page-item me-2">
                <a
                  className="d-flex justify-content-center align-items-center"
                  href="/services/carwash?page=2"
                >
                  next <i className="ti ti-arrow-right ms-2" />
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>


      <Footer />
    </>
  );
};

export default CategoryTest;
